import { render, staticRenderFns } from "./WaitingforCommercializingOpportunities.vue?vue&type=template&id=661ca39f&"
import script from "./WaitingforCommercializingOpportunities.vue?vue&type=script&lang=js&"
export * from "./WaitingforCommercializingOpportunities.vue?vue&type=script&lang=js&"
import style0 from "./WaitingforCommercializingOpportunities.vue?vue&type=style&index=0&id=661ca39f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports